const ORIGIN = "https://insightproperties.co.uk";

const SITE_NAME = "Insight Properties";

export const SEO = {
  "/": {
    title: "Insight Properties | Rent-to-Rent & Supported Housing in the North West",
    description:
      "Hands-off rent-to-rent for landlords and safe, compliant supported housing for councils across Greater Manchester, Liverpool and the North West. One agreed monthly rent, fully managed.",
    keywords:
      "rent to rent North West, supported housing provider, landlords Manchester, property management North West, social housing, Insight Properties",
    og: "og-home.png",
  },
  "/about": {
    title: "About Insight Properties | People-First Housing Partner, North West",
    description:
      "Insight Properties is a specialist rent-to-rent and supported housing provider putting people before portfolios across Greater Manchester and the North West of England.",
    keywords:
      "about Insight Properties, ethical housing provider, supported housing North West, rent to rent company Manchester",
    og: "og-about.png",
  },
  "/services": {
    title: "Services | Rent-to-Rent & Supported Housing | Insight Properties",
    description:
      "Two focused services: long-term rent-to-rent for landlords and CQC/HMO-compliant supported housing for councils and providers — fully managed, end to end.",
    keywords:
      "rent to rent service, supported housing service, HMO compliant accommodation, guaranteed rent alternative, property management North West",
    og: "og-services.png",
  },
  "/landlords": {
    title: "For Landlords | Hands-Off Rent-to-Rent, Simple 15% Fee | Insight Properties",
    description:
      "Turn your property into a hands-off investment: one agreed monthly rent, no void-period hassle and full management for a simple, transparent 15% fee across the North West.",
    keywords:
      "landlords rent to rent, hands off letting, no void periods, property management fee, let my property Manchester, North West landlords",
    og: "og-landlords.png",
  },
  "/local-authorities": {
    title: "For Local Authorities | Supported Housing Partner | Insight Properties",
    description:
      "A dependable supported-housing partner for councils and housing associations: rapid placement, 24/7 tenant support and compliance-first accommodation across the North West.",
    keywords:
      "supported housing local authorities, council accommodation provider, housing association partner, temporary accommodation North West, vulnerable people housing",
    og: "og-councils.png",
  },
  "/contact": {
    title: "Contact Insight Properties | Rent-to-Rent & Supported Housing, North West",
    description:
      "Talk to Insight Properties about hands-off rent-to-rent or quality supported housing across the North West. Email contact@insightproperties.co.uk — reply within one working day.",
    keywords:
      "contact Insight Properties, rent to rent enquiry, supported housing enquiry, North West housing contact",
    og: "og-contact.png",
  },
};

function upsertMeta(selector, attr, key, content) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function applySeo(pathname) {
  const data = SEO[pathname] || SEO["/"];
  const url = ORIGIN + (pathname === "/" ? "" : pathname);
  const image = `${ORIGIN}/brand/og/${data.og}?v=3`;

  document.title = data.title;
  upsertMeta('meta[name="description"]', "name", "description", data.description);
  upsertMeta('meta[name="keywords"]', "name", "keywords", data.keywords);
  upsertLink("canonical", url);

  upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", SITE_NAME);
  upsertMeta('meta[property="og:type"]', "property", "og:type", "website");
  upsertMeta('meta[property="og:title"]', "property", "og:title", data.title);
  upsertMeta('meta[property="og:description"]', "property", "og:description", data.description);
  upsertMeta('meta[property="og:url"]', "property", "og:url", url);
  upsertMeta('meta[property="og:image"]', "property", "og:image", image);
  upsertMeta('meta[property="og:image:width"]', "property", "og:image:width", "1200");
  upsertMeta('meta[property="og:image:height"]', "property", "og:image:height", "630");

  upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
  upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", data.title);
  upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", data.description);
  upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", image);
}
